import ForgotPassword from './ForgotPassword'
import { AccessType } from 'app/auth/accessControlService'
import { Routes } from 'app/services/routeService/routeService'

export const ForgotPasswordConfig = {
  settings: {
    layout: {
      config: {
        navbar: {
          display: false,
        },
        toolbar: {
          display: false,
        },
        footer: {
          display: false,
        },
        leftSidePanel: {
          display: false,
        },
        rightSidePanel: {
          display: false,
        },
      },
    },
  },
  routes: [
    {
      path: Routes.forgotPassword(),
      component: ForgotPassword,
      accesses: [AccessType.ANNONYMOUS],
    },
  ],
}
